/** Dan's PV prefilled outcomes 2026.xlsx, Sheet1. Blank outcomes stay unanswered. */
import { clausesInSection } from './clause-library.js';
export const PV_INITIAL_OUTCOMES = {
    'DC3.1': 'Not Applicable',
    'DC3.2': 'Not Applicable',
    GENERAL8: 'Compliant',
    GENERAL9: 'Compliant',
    INSTALL5: 'Compliant',
    INSTALL7: 'Compliant',
    GENERAL10: 'Compliant',
    GENERAL11: 'Compliant',
    'COMPONENTS1.1': 'Compliant',
    CER1: 'Compliant',
    CER2: 'Compliant',
    CER3: 'Compliant',
    CER4: 'Compliant',
    CER5: 'Not Applicable',
    'DC1.1.1.1.1.1.1': 'Not Applicable',
    'DC1.1.2.1.1.1': 'Not Applicable',
    'DC1.2.1.1.1.1.1': 'Compliant',
    'DC1.3.1.1.1.1': 'Compliant',
    'DC1.4.1': 'Compliant',
    'DC1.5.1.1.1': 'Compliant',
    'DC1.6.1': 'Compliant',
    'DC1.7': 'Compliant',
    'DC1.8.1': 'Compliant',
    'DC1.9.1': 'Not Applicable',
    'DC2.1.1.1.1.1': 'Not Applicable',
    'DC2.2.1': 'Not Applicable',
    'DC2.3.1': 'Not Applicable',
    'DC2.4.1': 'Compliant',
    'DC2.5.1': 'Compliant',
    'DC2.7': 'Not Applicable',
    'DC2.8': 'Compliant',
    GENERAL3: 'Compliant',
    GENERAL7: 'Not Applicable',
    'INSTALL1.1': 'Compliant',
    'INSTALL2.1.1': 'Compliant',
    'INSTALL3.1.1': 'Compliant',
    'INSTALL4.1.1': 'Compliant',
    'MECH2.1': 'Not Applicable',
    'PROTECTION1.1': 'Not Applicable',
    'PROTECTION2.1.1': 'Not Applicable',
    'PROTECTION4.1': 'Compliant',
    PROTECTION6: 'Not Applicable',
    'PROTECTION7.1': 'Not Applicable',
    'SIGN1.1': 'Not Applicable',
    SIGN10: 'Not Applicable',
    'PROTECTION3.1': 'Not Applicable',
    'WIRING16.1.1': 'Compliant',
    'WIRING16.2.1.1': 'Compliant',
    WIRING17: 'Compliant',
    'WIRING4.1': 'Compliant',
    'WIRING5.1.1': 'Compliant',
    'WIRING6.2': 'Not Applicable',
    'WIRING8.1': 'Compliant',
    'WIRING8.2': 'Compliant',
};
export const PV_INITIAL_FINAL_ITEMS = {
    P1: 'R',
    P13: 'N/A',
    P14: 'No',
    P15: 'N/A',
    P5: 'Yes. All on same roof face per MPPT.',
    P6: 'No',
    P7: 'N/A',
    P8: 'N/A',
    P9: 'N/A',
};
/** Use the library's canonical ID (some GENERAL identifiers contain spaces). */
export function initialPvChecklist() {
    return clausesInSection('cer-pv').flatMap((clause) => {
        const outcome = PV_INITIAL_OUTCOMES[clause.clauseId.replace(/\s+/g, '')];
        return outcome
            ? [
                {
                    section: 'cer-pv',
                    clauseId: clause.clauseId,
                    outcome,
                    assessment: outcome === 'Compliant' ? 'compliant' : 'not_applicable',
                    photoIds: [],
                },
            ]
            : [];
    });
}
/** P10 and P11 are percentages; P12 is their combined percentage. */
export function pvPerformanceEstimate(responses) {
    const parse = (text) => {
        if (!text?.trim() || !/^\d+(?:\.\d+)?\s*%?$/.test(text.trim()))
            return undefined;
        const n = Number(text.replace('%', '').trim());
        return n >= 0 && n <= 100 ? n : undefined;
    };
    const p10 = parse(responses.P10), p11 = parse(responses.P11);
    return p10 === undefined || p11 === undefined
        ? undefined
        : `${Number(((p10 * p11) / 100).toFixed(2))}%`;
}
//# sourceMappingURL=pv-prefills.js.map